<template>
  <div>
    <Head title="Create Entry" />

    <div class="flex items-center justify-between mb-6">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/directories"><small>Back</small></Link>
        <span class="text-indigo-400 font-medium"> |</span> New Registration
      </h1>
      <!-- <Link class="btn-indigo" @click="toggleModal()">
        <span class="hidden md:inline">💬&nbsp;Comments (0)</span>
      </Link> -->
      <a class="btn-indigo cursor-pointer flex items-center px-6 py-4 focus:text-indigo-500" @click="toggleModal()">
        💬&nbsp;Comments (0)
      </a>      
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
        <form-wizard step-size="xs">
          <tab-content title="Company Info">
            <form @submit.prevent="store">
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
              <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
              <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Phone" />
              <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Address" />
              <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2" label="City" />
              <text-input v-model="form.region" :error="form.errors.region" class="pb-8 pr-6 w-full lg:w-1/2" label="Province/State" />
              <select-input v-model="form.country" :error="form.errors.country" class="pb-8 pr-6 w-full lg:w-1/2" label="Country">
                <option :value="null" />
                <option value="CA">Canada</option>
                <option value="US">United States</option>
              </select-input>
              <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Postal code" />
              </div>
              <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                <loading-button :loading="form.processing" class="btn-indigo" type="submit">Save</loading-button>
              </div>
          </form>
        </tab-content>
        <tab-content title="Company Details">
          Company Details
        </tab-content>
        <tab-content title="Supporting Documents">
          Supporting Documents
        </tab-content>
        <tab-content title="Verifications">
          Verifications
        </tab-content>
      </form-wizard>     

    </div>

    <Modal @close="toggleModal" :modalActive="modalActive">
      <div>
        <Link class="btn-indigo items-center float-right" :href="`/matches/${match_id}/config`" tabindex="-1">
          Result
        </Link>         
        <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-2">Agent</th>
            <th class="pb-4 pt-6 px-2">Total</th>
            <th class="pb-4 pt-6 px-2">Wins</th>
          </tr>
        </thead>
        <tbody>
          <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <a class="flex items-center px-2 py-4 focus:text-indigo-500">
                <icon name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </a>
            </td>
            <td class="border-t">
              <a class="flex items-center px-2 py-4 float-right" tabindex="-1">
               xxx
              </a>
            </td>
            <!-- <td class="border-t">
              <a class="flex items-center px-2 py-4" tabindex="-1">
                {{ booking.status }}
              </a>
            </td> -->
            <td class="border-t">
              <a class="flex items-center px-2 py-4" tabindex="-1">
                xx
              </a>
            </td>
          </tr>

        </tbody>

        <!-- <tfoot>
          <tr class="text-left font-bold">
            <th class="text-lg pb-4 pt-6 px-6 float-right">Collections</th>
            <th class="text-lg pb-4 pt-6 px-6"><span class="float-right">{{ total }}</span></th>
            <th class="text-lg pb-4 pt-6 px-6 float-right">Payout</th>
            <th class="text-lg pb-4 pt-6 px-6">0.00</th>
            <th class="text-lg pb-4 pt-6 px-6" colspan="2">
              <Link class="btn-indigo flex items-center" :href="`/matches/${match_id}/config`" tabindex="-1">
                Result
              </Link> 
            </th>
          </tr>
        </tfoot>         -->
        
      </table>

      </div>
    </Modal>   

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import { ref } from "vue";
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import {FormWizard, TabContent} from 'vue3-form-wizard'
import '../../../../node_modules/vue3-form-wizard/dist/style.css'
//import '../../../../node_modules/vue-form-wizard/dist/vue-form-wizard.js'
import json from '@/Shared/data.json'
import Modal from "@/Shared/Modal.vue";

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    FormWizard,
    TabContent,
    Modal,
  },
  setup() {
    const modalActive = ref(false);

    const toggleModal = () => {
      modalActive.value = !modalActive.value;
    };

    
    return { modalActive, toggleModal };
  },  
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        email: null,
        phone: null,
        address: null,
        city: null,
        region: null,
        country: null,
        postal_code: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/organizations')
    },
  },
}
</script>
